<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> Daftar <strong>Instruktur</strong> yang ditugaskan </h1>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnFilter="true"
          :btnAdd="$allow('psp-instruktur-penugasan.create')"
          :btnDownload="false"
          @add="onAdd"
          @reload="onReload"
          @filter="onFilter"
          @download="onDownload"
        >
          <template v-slot:subtitle>
            <div class="mt-4 subtitle-1 black--text"> {{ total }} Instruktur ditugaskan</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="onSaveFilter"
      />
      <v-card-text class="pa-0">
        <div>
          <base-list-table
            :hideHeader="true"
            :loading="loading"
            :item="data"
            :total="total"
            :usePaging="false"
            @fetch="fetchData"
          >
            <template slot-scope="{ item }">
              <td>
                <v-list-item dense class="px-0">
                  <v-list-item-content>
                    <v-row>
                      <v-col class="pt-1" cols="12" md="4">
                        <v-list-item class="px-0">
                          <v-list-item-avatar color="secondary">
                            <v-icon dark style="font-size: 30px">mdi-account</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content class="py-0 my-3">
                            <span class="caption orange--text text--darken-2">Data Instruktur</span>
                            <div class="subtitle-2 black--text" style="line-height: 1rem">
                              {{ $getDeepObj(item, 'nama') || '-' }}
                            </div>
                            <div style="font-size: 12px">
                              <span class="info--text">Email:</span> {{ $getDeepObj(item, 'email') || '-' }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="pt-1" cols="12" md="8">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption orange--text text--darken-2">Data Penugasan</span>
                            <v-row no-gutters>
                              <template v-for="(tugas, id) in $getDeepObj(item, 'psp_instrukturs.data')">
                                <v-col cols="12" :key="id">
                                  <v-row class="my-1">
                                    <v-col class="py-0" cols="12" md="5">
                                      <div style="font-size: 12px" class="info--text">Instansi Bertugas</div>
                                      {{ $getDeepObj(tugas, 'instansi.data.nama') }}
                                    </v-col>
                                    <v-col class="py-0" cols="12" md="3">
                                      <div style="font-size: 12px" class="info--text">Jenjang</div>
                                      {{ $getDeepObj(tugas, 'm_jenjang.data.singkat') }}
                                    </v-col>
                                    <v-col class="py-0" cols="12" md="4">
                                      <div style="font-size: 12px" class="info--text">Instruktur</div>
                                      {{ tugas.is_ksps === 1 ? 'Diklat KSPS' : 'Diklat Guru' }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </template>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </v-list-item-action-text>
                </v-list-item>
              </td>
            </template>
          </base-list-table>
        </div>
        <v-card-actions class="pt-0">
          <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" generalError :title="formulir.title" @save="onSave">
      <form-tambah
        ref="formulir"
        :initValue="formulir.init"
        :action="formulir.action"
        :masters="masters"
        :p4tk="instansiP4tk"
      />
    </base-modal-full>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import FormTambah from './Add';
import actions from './actions';
export default {
  mixins: [list],
  components: { FormTambah },
  data() {
    return {
      instansiP4tk: {},
      formulir: {},
      actions: actions,
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    formFilter() {
      return [
        {
          label: 'Pilih Instansi Bertugas',
          model: 'instansi_id',
          type: 'select',
          props: ['attach'],
          master: this.$mapForMaster(this.instansiP4tk),
          labelColor: 'secondary',
          grid: { cols: 12 },
        },
      ];
    },

    filtered() {
      let label = [];
      for (let key in this.filters) {
        let value = this.filters[key];
        if (key === 'instansi_id') {
          label.push(this.instansiP4tk[value] || '');
        }
      }
      return label;
    },
  },
  created() {
    this.fetchInstansiP4tk();
    this.getMasters('jenjang|value:singkat');
  },
  methods: {
    ...mapActions('preferensi', ['getInstansiP4tk']),
    ...mapActions('master', ['getMasters']),
    ...mapActions('penugasan', ['fetch', 'create', 'update', 'action', 'downloadList']),

    async fetchInstansiP4tk() {
      const listInstansi = await this.getInstansiP4tk();

      for (const ins of listInstansi.data) {
        this.instansiP4tk[ins.instansi_id] = ins.nama;
      }
    },

    allow(action, data) {
      let disabled = false;
      switch (action.event) {
        default:
          disabled = this.$allow(action.akses, data.policies);
          break;
      }
      return disabled;
    },

    confirmHtml(data, action, isMulti) {
      const pspInstruktur = this.$getDeepObj(data, 'psp_instrukturs.data.0') || {};

      return [
        `<div>Anda ingin <strong class="orange--text text--darken-2">${
          action === 'delete' ? 'menghapus' : 'mengubah'
        }</strong> data penugasan Instruktur berikut?</div>`,
        `<div class="v-list-item__content py-0 my-3">`,
        `<div class="subtitle-2 black--text" style="line-height: 1rem;">${data.nama}</div>`,
        `<div style="font-size: 12px;">`,
        `<span class="grey--text text--darken-1">Email:</span> ${data.email}`,
        !isMulti
          ? `<br /><span class="grey--text text--darken-1">Instansi:</span> ${this.$getDeepObj(
              pspInstruktur,
              'instansi.data.nama'
            )}`
          : '',
        `</div>`,
        `</div>`,
        isMulti
          ? `<div style="font-size: 12px" class="mt-3 orange--text text--darken-2">Silahkan pilih instansi tugas yang ingin ${
              action === 'delete' ? 'dihapus' : 'diubah'
            }</div>`
          : '',
      ].join('');
    },

    onAdd() {
      this.$set(this.formulir, 'title', 'Tambah Penugasan Instruktur');
      this.$set(this.formulir, 'action', 'create');
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onEdit(item) {
      const pspInstrukturs = this.$getDeepObj(item, 'psp_instrukturs.data') || [];
      let form = { desc: this.confirmHtml(item, 'edit', pspInstrukturs.length > 1) };
      let pspInstrukturId = null;
      let pspInstruktur = {};
      let akun = {};

      this.$set(this.formulir, 'title', 'Ubah Data Penugasan');
      this.$set(this.formulir, 'action', 'update');

      if (pspInstrukturs.length > 1) {
        form.render = (h) => {
          return h(
            'select',
            {
              class: 'custom-select',
              domProps: {
                value: '',
              },
              on: {
                input: function(event) {
                  pspInstrukturId = event.target.value;
                },
              },
            },
            [
              h('option', { attrs: { value: '' } }, '-- Pilih Instansi --'),
              pspInstrukturs.map((tugas) =>
                h(
                  'option',
                  { attrs: { value: tugas.psp_instruktur_id } },
                  this.$getDeepObj(tugas, 'instansi.data.nama')
                )
              ),
            ]
          );
        };

        this.$confirm('', 'Ubah Data Penugasan', {
          tipe: 'warning',
          form: form,
          lblConfirmButton: 'Lanjut',
        }).then(() => {
          if (pspInstrukturs.length > 1 && !pspInstrukturId) {
            this.$error('Silakan pilih instansi bertugas!');
            return;
          }

          pspInstruktur = pspInstrukturs.filter((ins) => Number(ins.psp_instruktur_id) === Number(pspInstrukturId));
          akun = Object.assign({}, pspInstruktur[0] || {}, { akun: item });

          this.$refs.modal.open();
          this.$nextTick(() => {
            this.$refs.formulir.reset();
            this.$set(this.formulir, 'init', Object.assign({}, akun, { id: pspInstrukturId }));
          });
        });
      } else {
        pspInstruktur = this.$getDeepObj(item, 'psp_instrukturs.data.0') || {};
        akun = Object.assign({}, pspInstruktur, { akun: item });

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'init', Object.assign({}, akun, { id: pspInstrukturId }));
        });
      }
    },

    onDelete(item) {
      const pspInstrukturs = this.$getDeepObj(item, 'psp_instrukturs.data') || [];
      let form = { desc: this.confirmHtml(item, 'delete', pspInstrukturs.length > 1) };
      let pspInstrukturId = null;

      if (pspInstrukturs.length > 1) {
        form.render = (h) => {
          return h(
            'select',
            {
              class: 'custom-select',
              domProps: {
                value: '',
              },
              on: {
                input: function(event) {
                  pspInstrukturId = event.target.value;
                },
              },
            },
            [
              h('option', { attrs: { value: '' } }, '-- Pilih Instansi --'),
              pspInstrukturs.map((tugas) =>
                h(
                  'option',
                  { attrs: { value: tugas.psp_instruktur_id } },
                  this.$getDeepObj(tugas, 'instansi.data.nama')
                )
              ),
            ]
          );
        };
      }

      this.$confirm('', 'Hapus Data', {
        tipe: 'error',
        form: form,
        lblConfirmButton: 'Hapus',
      }).then(() => {
        if (pspInstrukturs.length > 1 && !pspInstrukturId) {
          this.$error('Silakan pilih instansi bertugas!');
          return;
        }

        if (!pspInstrukturId) {
          pspInstrukturId = this.$getDeepObj(item, 'psp_instrukturs.data.0.psp_instruktur_id') || '';
        }

        this.action({ id: pspInstrukturId, type: 'delete' }).then(() => {
          this.$success('Akun berhasil di hapus');
          this.onReload();
        });
      });
    },

    onSave() {
      const action = this.formulir.action;
      const id = this.$refs.formulir.getId();
      const params = this.$refs.formulir.getValue();

      if (!action) {
        this.$error('Aksi simpan belum ditentukan');
        this.$refs.modal.loading = false;
        return;
      }

      if (!id) {
        this.$error('Akun calon instruktur belum dipilih');
        this.$refs.modal.loading = false;
        return;
      }

      this[action]({ params, id })
        .then(() => {
          this.$success(`Data penugasan berhasil ditambahkan`);
          this.$refs.modal.close();
          this.fetchData();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSaveFilter(filters) {
      // set filter
      this.filters = filters;
      Object.assign(this.params, { page: 1 });
      this.onReload();
      this.$refs.filter.close();
    },

    onDownload() {
      const M_LAPORAN = [
        {
          key: 'download',
          label: `Daftar Penugasan Instruktur`,
        },
      ];

      let url = {};
      this.$confirm('Pilih jenis berkas yang ingin diunduh?', 'Unduh Berkas', {
        form: {
          desc: 'Pilih berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function(event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Laporan --'),
                M_LAPORAN.map((laporan) => h('option', { attrs: { value: laporan.key } }, laporan.label)),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
        this.downloadList({ params, url: url.dokumen }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
